module.exports = "<div class=\"wrapper {{ wrapperClass }}\">\n    <div class=\"sidebar\" data-color=\"purple\" data-image=\"\">\n        <app-sidebar></app-sidebar>\n        <div class=\"sidebar-background\" style=\"background-image: url(/assets/img/sidebar-5.jpg)\"></div>\n    </div>\n\n    <div class=\"{{ panelClass }}\">\n        <navbar-cmp></navbar-cmp>\n        <router-outlet></router-outlet>\n    </div>\n\n    <toaster-container></toaster-container>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main